
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"data-name":"vuesax/twotone/house-2","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#bac1cc"}},[_c('path',{attrs:{"d":"M22 22.75H2a.75.75 0 01-.75-.75.75.75 0 01.75-.75h20a.75.75 0 01.75.75.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M3.7 22.003l-1.5-.006.05-12.03a2.778 2.778 0 011.054-2.155l7-5.45a2.763 2.763 0 013.377 0l7 5.443A2.729 2.729 0 0121.75 9.97V22h-1.5V9.97a1.239 1.239 0 00-.48-.987l-7-5.44a1.261 1.261 0 00-1.539 0l-7 5.448a1.268 1.268 0 00-.481.979z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M8.5 10.25h7a2.253 2.253 0 012.25 2.25V22a.75.75 0 01-.75.75H7a.75.75 0 01-.75-.75v-9.5a2.253 2.253 0 012.25-2.25zm7.75 11V12.5a.751.751 0 00-.75-.75h-7a.751.751 0 00-.75.75v8.75z","opacity":".4"}}),_c('path',{attrs:{"data-name":"Vector","d":"M10 18.5a.75.75 0 01-.75-.75v-1.5a.75.75 0 01.75-.75.75.75 0 01.75.75v1.5a.75.75 0 01-.75.75z"}}),_c('path',{attrs:{"data-name":"Vector","d":"M13.5 8.25h-3a.75.75 0 01-.75-.75.75.75 0 01.75-.75h3a.75.75 0 01.75.75.75.75 0 01-.75.75z","opacity":".4"}})])])
          )
        }
      }
    